var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternshipsSalary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dollar-circle-svgrepo-com",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55032",
    "data-name": "Path 55032",
    d: "M10,4a6,6,0,1,0,6,6A6.007,6.007,0,0,0,10,4Zm.75,9.686V14.5H9.25v-.81A2.36,2.36,0,0,1,7,11.5H8.5c.008.107.119.75,1.5.75,1.035,0,1.5-.439,1.5-.75,0-.243,0-.75-1.5-.75-2.61,0-3-1.41-3-2.25A2.384,2.384,0,0,1,9.25,6.314v-.8h1.5v.832A2.251,2.251,0,0,1,12.55,8.5H11.8l-.75.013c-.01-.285-.161-.764-1.05-.764-.974,0-1.5.387-1.5.75,0,.28,0,.75,1.5.75,2.61,0,3,1.41,3,2.25A2.384,2.384,0,0,1,10.75,13.686Z",
    transform: "translate(-0.5 -0.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55033",
    "data-name": "Path 55033",
    d: "M9.5,2A7.5,7.5,0,1,0,17,9.5,7.509,7.509,0,0,0,9.5,2Zm0,13.5a6,6,0,1,1,6-6A6.007,6.007,0,0,1,9.5,15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55034",
    "data-name": "Path 55034",
    d: "M11,9.753c-1.5,0-1.5-.47-1.5-.75,0-.363.526-.75,1.5-.75.889,0,1.039.479,1.05.764L12.8,9h.75a2.251,2.251,0,0,0-1.8-2.159V6.012h-1.5v.8A2.384,2.384,0,0,0,8,9c0,.84.39,2.25,3,2.25,1.5,0,1.5.507,1.5.75,0,.311-.465.75-1.5.75-1.381,0-1.492-.643-1.5-.75H8a2.36,2.36,0,0,0,2.25,2.19V15h1.5v-.814A2.384,2.384,0,0,0,14,12c0-.84-.39-2.25-3-2.25Z",
    transform: "translate(-1.5 -1.003)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternshipsSalary);
export default __webpack_public_path__ + "static/media/internships-salary.b607234f73f05dce8eac467b9886a570.svg";
export { ForwardRef as ReactComponent };